(function () {
  function init() {
    var section = document.querySelector('[data-section-type="product"]');
    if (!section) return;

    var priceWrap = section.querySelector('[data-subscription-strikethrough]');
    if (!priceWrap) return;

    var priceEl = priceWrap.querySelector('[data-price]');
    var compareEl = priceWrap.querySelector('[data-compare-price]');
    if (!priceEl || !compareEl) return;

    var display = document.createElement('span');
    display.setAttribute('data-subscription-display', '');
    display.style.display = 'none';
    priceEl.parentNode.insertBefore(display, priceEl.nextSibling);

    function render() {
      var visibleBlock = section.querySelector(
        '.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden)'
      );
      var checked = visibleBlock && visibleBlock.querySelector('input[data-radio-type]:checked');
      var isSubscription = checked && checked.dataset.radioType === 'selling_plan';

      if (isSubscription) {
        var price = checked.dataset.variantPrice || '';
        var compareAt = checked.dataset.variantCompareAtPrice || '';
        display.innerHTML = compareAt
          ? '<s>' + compareAt + '</s> ' + price
          : price;
        display.style.display = '';
        priceEl.style.display = 'none';
        compareEl.style.display = 'none';
      } else {
        display.style.display = 'none';
        display.innerHTML = '';
        priceEl.style.display = '';
        compareEl.style.display = '';
      }
    }

    section.addEventListener('change', render);

    var widgetContainer = section.querySelector('.shopify_subscriptions_app_container');
    if (widgetContainer) {
      new MutationObserver(render).observe(widgetContainer, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true,
      });
    }

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
